module.exports = __webpack_public_path__ + "static/media/SkillIcon.76211523.svg";